import React from 'react'

import { Color23, Colors23 } from '@grammarly/badger-ui'

interface IconDropdownArrow extends React.SVGProps<SVGSVGElement> {
  color?: Color23
}

export const IconDropdownArrow = ({ color, ...rest }: IconDropdownArrow) => (
  <svg width="12" height="12" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      d="M2.42066 1L4 3.25621L5.57934 1H2.42066Z"
      stroke={color ? Colors23[color] : 'currentColor'}
      strokeWidth="2"
    />
  </svg>
)
